import { Component, OnInit, Self } from "@angular/core";
import { UserDto } from "../../../api/models/user-dto";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "../../../api/services/authentication.service";
import Swal from "sweetalert2";
import { colors } from "../../../colors.const";
import { EntityModalComponent } from "../../../util/components/modal/entity-modal.component";
import { EnumService } from "../../../util/service/enum.service";
import { UserFormGroupService } from "../user-form-group.service";
import { CaslAction } from "../../../server/enums/casl-action.enum";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { OfficeNameDto } from "app/api/models";
import { UserRole } from "app/server/enums/user-role.enum";
import { OfficeService } from "app/api/services";
import { AuthService } from "app/util/service/auth.service";

@Component({
  selector: "app-user-modal",
  templateUrl: "./user-modal.component.html",
  styleUrls: ["./user-modal.component.scss"],
  providers: [UserFormGroupService],
  standalone: false,
})
export class UserModalComponent extends EntityModalComponent<UserDto> implements OnInit {
  userRoles!: Array<{ value: string }>;
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;
  protected readonly UserRole = UserRole;

  offices!: OfficeNameDto[];

  get isAdmin() {
    return this.formGroup.get("role")?.value === UserRole.Admin;
  }

  constructor(
    @Self() public formGroupService: UserFormGroupService,
    public modal: NgbActiveModal,
    private toastrService: ToastrService,
    private authenticationService: AuthenticationService,
    private enumService: EnumService,
    private officeService: OfficeService,
    private authService: AuthService
  ) {
    super();
  }

  get rollenArray() {
    return this.formGroupService.rollenArray;
  }

  override ngOnInit(): void {
    this.offices = this.data["offices"];
    this.userRoles = this.enumService.userRoleDropdownOptions.filter(
      (role) => role.value !== UserRole.Admin || this.authService.currentUserValue?.role === UserRole.Admin
    );

    super.ngOnInit();
  }

  async resetPassword() {
    const confirmed = await Swal.fire({
      titleText: "Passwort zurücksetzen",
      text: "Wenn Sie fortfahren, bekommt der Benutzer eine E-Mail, über die das Passwort zurückgesetzt werden kann.",
      icon: "info",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.info,
      confirmButtonText: "E-Mail senden",
      cancelButtonText: "Abbrechen",
    });
    if (!confirmed.isConfirmed) {
      return;
    }

    this.authenticationService
      .authControllerSendForgotPasswordEmail({
        body: { email: this.entity.email },
      })
      .subscribe(() =>
        this.toastrService.success(
          "Der Benutzer hat eine E-Mail bekommen, über die das Passwort zurückgesetzt werden kann",
          "E-Mail versendet"
        )
      );
  }
}
